import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { first, map } from 'rxjs/operators';
import { lastValueFrom } from 'rxjs';
import { authState } from '@angular/fire/auth';
import { BaseInjectorService } from '../base/base-service.injector';
import { TreasurehuntService } from '../services/treasureHunt/treasurehunt.service';
@Injectable({
  providedIn: 'root',
})
export class treasureHuntResolverService extends BaseInjectorService {
  constructor(public treasurehuntService: TreasurehuntService) {
    super();
  }
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = await this.isLoggedIn();

    const data = await this.lhStorage.get('appData');

    if (user && data != null) {
      // await this.overlayService.presentLoading(this.createLoaderOptions("loading..."));

      const treasurehuntInfo = await this.getTreasureHuntDetails();

      // await this.overlayService.dismissLoading();
    }
  }

  async getTreasureHuntDetails(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      await this.treasurehuntService.getTreasureHuntInfo();
      resolve('');
    });
  }

  isLoggedIn() {
    return lastValueFrom(authState(this.firebaseAuth).pipe(first()));
  }
}
